import styled from 'styled-components';

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const CardsRoot = styled.div`
  display: flex;
  width: 100%;
  gap: 24px;
`;
